var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPieChartGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#475B7F",
    d: "M16.363 19.705c.277.281.256.758-.064.988a9.54 9.54 0 01-5.471 1.806c-5.184.065-9.646-4.244-9.822-9.5C.834 7.884 4.519 3.614 9.338 2.923c.382-.055.721.267.721.659v9.732l6.304 6.392z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F9BB3",
    d: "M21.707 10.655c-.335-4.9-4.196-8.814-9.027-9.154-.369-.024-.68.291-.68.666v9.177h9.05c.37 0 .68-.315.657-.689zm.638 2.658H12.75l6.39 6.48a.643.643 0 00.897.027 9.866 9.866 0 002.958-5.777.652.652 0 00-.649-.73z"
  }))));
}

export default SvgPieChartGray;